module.exports = __webpack_public_path__ + "img/second_fr.ef8f4693.jpg";